import * as Yup from 'yup'

export const schema = (t: (val: string) => string) => ({
  kam: Yup.string().required(t('requiredMessage')),
})
